// access-denied.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

  constructor(
    private router: Router,
    private location: Location
  ) {}


  protected readonly Date = Date;

  ngOnInit(): void {

  }

  goHome(): void {
    this.router.navigate(['/']);
  }

  goBack(): void {
    this.router.navigate(['learning-center']);
  }
}
